import { common } from '@ocean/ui'
import {
  Information,
  InformationTitle,
  InformationGrid,
  InformationGridItem,
} from './DetailsInformationGridLayout.styled'

const { Typography } = common

type DetailsInformationGridLayoutProps = {
  title?: string
  children: Array<React.ReactNode> | React.ReactNode
}

const DetailsInformationGridLayout: React.FC<DetailsInformationGridLayoutProps> = ({
  title,
  children,
}) => {
  function renderItems() {
    if (!children) return null

    const normalizedChildren = Array.isArray(children) ? children : [children]

    return normalizedChildren.map((item: any, index: number) => {
      if (!item) return null
      return <InformationGridItem key={index}>{item}</InformationGridItem>
    })
  }

  return (
    <Information>
      <InformationTitle>
        <Typography variant='h3' dataTest='DetailsInformationGridLayoutTitle'>
          {title}
        </Typography>
      </InformationTitle>
      <InformationGrid>{renderItems()}</InformationGrid>
    </Information>
  )
}

export default DetailsInformationGridLayout
